<!--配件多选弹窗-->
<template>
  <el-dialog :title="title" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
             :visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog" width="90%"
             style="position: absolute; top: -40px;background-color: rgb(38 38 38 / 70%);"
             @close="dialogClose" v-el-drag-dialog v-el-dialog-center>
    <template>
      <div id="containt">
        <div class="grid-height" style="display:flex">
          <div class="left_tree">

            <div
              style="padding: 5px;margin: 2px 8px;border: 1px solid #ededed;">
              <div class="title">
                <svg t="1676961094129" class="icon tree_icon" viewBox="0 0 1024 1024"
                     version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2887" width="20" height="20">
                  <path
                    d="M384 725.333333c0 21.333333 17.066667 38.4 38.4 42.666667H640v-42.666667c0-21.333333 17.066667-38.4 38.4-42.666666H853.333333c25.6 0 42.666667 17.066667 42.666667 42.666666v170.666667c0 25.6-17.066667 42.666667-42.666667 42.666667h-170.666666c-25.6 0-42.666667-17.066667-42.666667-42.666667v-42.666667h-213.333333c-68.266667 0-123.733333-51.2-128-119.466666V341.333333H170.666667c-21.333333 0-38.4-17.066667-42.666667-38.4V128c0-25.6 17.066667-42.666667 42.666667-42.666667h341.333333c25.6 0 42.666667 17.066667 42.666667 42.666667v170.666667c0 25.6-17.066667 42.666667-42.666667 42.666666H384v128h256v-42.666666c0-21.333333 17.066667-38.4 38.4-42.666667H853.333333c25.6 0 42.666667 17.066667 42.666667 42.666667v170.666666c0 25.6-17.066667 42.666667-42.666667 42.666667h-170.666666c-25.6 0-42.666667-17.066667-42.666667-42.666667v-42.666666H384v170.666666z m426.666667 42.666667h-85.333334v85.333333h85.333334v-85.333333z m0-298.666667h-85.333334v85.333334h85.333334v-85.333334z m-341.333334-298.666666H213.333333v85.333333h256V170.666667z"
                    fill="#1296db" p-id="2888"></path>
                </svg>

                <span>商品分类</span>
              </div>
              <el-input placeholder="关键字过滤" v-model="filterText">
              </el-input>

              <div style="overflow: auto; height: 312px">
                <el-tree class="tree-line" :data="data" lazy :load="loadChildNode" :props="defaultProps"
                         @node-click="handleNodeClick" :filter-node-method="filterNode" ref="tree" v-if="isRouterAlive">
                </el-tree>
              </div>
            </div>
          </div>
          <div class="table_main" style="height: 400px!important;">
            <div class="form_class">
              <vxe-form style="background-color: #f6f8fb;">
                <vxe-form-item title="配件编码">
                  <template>
                    <vxe-input v-model="formData1.partsCode" :clearable="true" type="text"/>
                  </template>
                </vxe-form-item>
                <vxe-form-item title="配件名称">
                  <template>
                    <vxe-input v-model="formData1.partsName" :clearable="true" type="text"/>
                  </template>
                </vxe-form-item>
                <vxe-form-item title="配件型号">
                  <template>
                    <vxe-input v-model="formData1.partsSpec" :clearable="true" type="text"/>
                  </template>
                </vxe-form-item>
              </vxe-form>
              <div class="clearfix screen-btns">
                <div class="fr" style="display: inline-block; float: right; margin-top: -39px;">
                  <vxe-button status="warning" style="height: 26px; margin-top: 7px" icon="el-icon-search"
                              class="button-sty"
                              @click="searchEvent">搜索
                  </vxe-button>
                </div>
              </div>
            </div>

            <vxe-table style="margin-top: 5px;"
                       :stripe="true"
                       :header-cell-style="{ height: '36px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', }"
                       :row-config="{ isHover: true, padding: 0, labelField: 'id', keyField: 'id'}"
                       :row-style="{ fontSize: '12px', height: '36px', padding: '0'}"
                       :cell-style="{  height: '36px' }"
                       show-overflow
                       :checkbox-config="{
                         labelField: '',
                         highlight: false,
                         reserve: true,
                         range: true,
                         checkMethod: ({row}) => {
                           if (this.enableSaleStat) {
                             return row.saleStat == 1
                           }
                           return true
                         }
                       }"
                       @checkbox-change="xTableChecked"
                       @checkbox-all="xTableChecked"
                       ref="xTable"
                       height="80%"
                       :column-config="{ resizable: true }"
                       :data="xTableData"
            >
              <vxe-column type="checkbox" width="40"/>
              <vxe-column title="配件编码" field="partsCode" width="180">
                <template #default="{row}">
                  <span v-if="row.saleStat == 1">{{row.partsCode}}</span>
                  <span v-else>{{row.partsCode}}<b style="color: red">(已停供)</b></span>
                </template>
              </vxe-column>
              <vxe-column title="配件名称" field="partsName" width="180"></vxe-column>
              <vxe-column title="配件型号" field="partsSpec" width="160"></vxe-column>
              <vxe-column title="可售状态" field="saleStat" width="160">
                <template #default="{row}">
                  <span v-if="row.saleStat == 1" class="txt-status">是</span>
                  <span v-else class="txt-status disable">否</span>
                </template>
              </vxe-column>
              <vxe-column field="bigCategoryName" title="产品大类"  width="120"></vxe-column>
              <vxe-column field="bigPartsCategoryName" title="配件大类"  width="120"></vxe-column>
              <!--              <vxe-column title="出库仓" field="warehouseName" width="180"></vxe-column>-->
              <!--              <vxe-column title='库存' field='qty' width="100"></vxe-column>-->
              <vxe-column  title='网点价（出厂价）' field='sitePrice' width="120">
                <template #default="{row}">
                  <span v-if="isSite">*</span>
                  <span v-else>{{ row.sitePrice }}</span>
                </template>
              </vxe-column>
              <vxe-column title='自有库存' field='invQty' width="120"></vxe-column>
              <!--              <vxe-column title='金额' field='amount' width="100"></vxe-column>-->
              <!--              <vxe-column title='占用数量' field='takeUpQty' width="100"></vxe-column>-->
            </vxe-table>

            <div style="float: left; height: 34px; font-size: 12px">
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </div>

          </div>
        </div>
      </div>
    </template>
    <label id="labBtn" class="transverse">
      <div class="icon">
        <i class="el-icon-more"></i>
        <i class="el-icon-more"></i>
      </div>
    </label>
    <div class="multipleChoice">
      <el-tooltip :enterable="false" effect="dark" content="全部删除" placement="top">
        <a class="allDel icon-quanbushanchu" @click="clearAllChecked()"></a>
      </el-tooltip>
      <div class="list">
        <div class="item" v-for="(checkRow, index) in checkRows" :key="checkRow.id">
          <p>{{ checkRow.partsName }}</p>
          <a class="el-icon-close" @click="clearChecked(checkRow)"></a>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">

			<el-button type="primary" plain class="button-sty" @click="dialogClose">
				<i class="el-icon-close el-icon"></i>
				取 消
			</el-button>
			<el-button type="primary" @click="confirm" class="button-sty">
				<i class="el-icon-check el-icon"></i>
				确 定
			</el-button>
		</span>
  </el-dialog>
</template>

<script>
import {fetchTree} from "@/api/admin/type_tree";
import pager from '@/components/pager/index.vue'
import api from "@/api/projectApi";
import checkboxTable from "@/mixins/selectDialog/checkboxTable";
import {siteMixins} from "@/mixins/tabChang";
import store from "@/store";


export default {
  name: 'partsCheckboxCommonDialog',
  props: ['visiable', 'param', 'enableSaleStat'],
  mixins: [checkboxTable, siteMixins],
  components: {pager},

  created() {
    const userInfo = store.getters.userInfo;
    if (userInfo.snUserId) {
      console.log("userInfo58585858585555555555555"+userInfo.snUserId)
      this.isSite = true;
    }
    // 参数初始化
    let param = this.param
    if (param) {
      this.$objCopy(this.param, this.formData)
      // if (param.siteId) {
      //   this.formData.siteId = param.siteId
      // }
      // if (param.excludePartsIdList) {
      //   this.formData.excludePartsIdList = param.excludePartsIdList
      // }
      // if (param.warehouseId) {
      //   this.formData.warehouseId = param.warehouseId
      // }
      // if (param.saleStat) {
      //   this.formData.saleStat = param.saleStat
      // }
      // if (param.costFix !== undefined) {
      //   this.formData.costFix = param.costFix
      // }
    }
  },

  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    total(newVal, oldVal) {
      this.$refs.pager.tableDataTotal = newVal
    }
  },

  data() {
    return {
      isSite: null,

      title: '配件选择',
      total: 0,
      filterText: '',
      defaultProps: {
        children: 'children',
        label: 'label',
        id: "id",
        isLeaf: "leaf"
      },
      data: [],
      pageSizes: [10, 20, 100],
      dataId: 0,
      showEdit: false,
      vxeOption: {},
      isRouterAlive: true,
      // 查询参数
      formData: {
        size: 0,
        current: 1,
        searchCount: false,
        usable: 1,
        partsCode: null,  // 编码,同厂商下惟一
        partsName: null,  // 名称
        partsSpec: null,  // 型号
        siteId: null,
        excludeIdList: null,
        bigCategoryId: null,
        smallCategoryId: null,
        warehouseId: null,
        saleStat: null,  // 可售状态：0否1是
        costFix: null,  // 维修物资：0否1是
        excludePartsIdList: null,
        // itemId: null,
        // excludePartsIds: null,
      },
      formData1: {
        partsCode: '',  // 编码,同厂商下惟一
        partsName: '',  // 名称
        partsSpec: '',  // 型号
      },
      showDialog: true,
      falseValue: false,
      selectMulti: true,

    };
  },


  methods: {


    // 分页功能
    changeTablePage(page, flag) {
      this.formData.size = page.pageSize
      this.formData.current = page.currentPage
      this.formData.searchCount = flag
      this.getTableData();
    },

    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },

    // 搜索
    searchEvent() {
      this.$objCopy(this.formData1, this.formData)
      this.$refs.pager.clearStoreTableDataTotal()
      this.formData.current = 1
      this.formData.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.getTableData()
    },


    reloadTree() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },

    // 点击的树形 点
    handleNodeClick(node, data) {
      this.$mask.open()

      let id = data.data.id;
      if (data.level === 1) {
        this.formData.bigCategoryId = id;
        this.formData.smallCategoryId = null;
      } else {
        this.formData.smallCategoryId = id;
      }

      this.getTableData();
      this.$mask.close()

    },

    getTableData() {
      this.$http.post(api.spPartsInv.getPartsPopPageUrl, this.formData).then(res => {
        this.total = res.data.data.total
        this.xTableData = res.data.data.records
      })
    },


    // 加载页面
    loadChildNode(node, resolve) {
      fetchTree({
        parentId: node.data.id,
        categoryType: 1
      }).then(({data}) => {
        resolve(
          data.data.map(item => {
            return {
              label: item.categoryName,
              id: item.id,
              leaf: Number(item.isChild) == 1 ? false : true,
            }
          })
        )
      });
    },

  }
};
</script>
<style lang="scss" scoped>
// 单选框的样式
::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon:before {
  top: -1px;
}

::v-deep.vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--checked-icon:after {
  top: 0.3em;
}

#containt .grid-height {
  height: 400px;
}

::v-deep .el-dialog {
  // height: 700px;
  overflow: hidden;
}

::v-deep body .dialog-style {
  border-radius: 8px;
  -webkit-box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  // height: 700px;
  overflow: hidden;
}

/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.table_main {
  padding-top: 5px;
  padding-left: 5px;
  border: 1px solid #ededed;
  width: calc(100% - 215px);
  border-bottom: none;

  .el-pagination {
    padding: 2px;

  }
}

.left_tree {
  width: 205px;

  .title {
    text-align: left;
    width: 182px;
    padding: 7px 0 5px !important;
    font-size: 13px;
    color: rgba(58, 39, 39, 0.96);

    > span {
      position: relative;
      left: 4px;
      top: -3px;
    }
  }

  ::v-deep.el-tree-node__label {
    width: calc(100% - 32px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
  }
}

.tree_icon {
  background: #f0f3ff;
}

// 重新修改tree组件样式
::v-deep.tree-line {
  .el-tree-node {
    position: relative;
    padding-left: 0px;
  }

  .el-tree-node__content {
    margin-top: 0px;
  }

  .el-tree-node__children {
    padding-left: 16px;
  }

  .el-tree-node::before {
    content: '';
    height: 100%;
    width: 1px;
    position: absolute;
    left: -3px;
    top: -26px;
    border-width: 1px;
    border-left: 1px dashed #d9d9d9;
  }

  .el-tree-node:last-child::before {
    height: 38px;
  }

  .el-tree-node::after {
    content: '';
    width: 24px;
    height: 1px;
    position: absolute;
    left: -3px;
    top: 12px;
    border-width: 1px;
    border-top: 1px dashed #d9d9d9;
  }

  & > .el-tree-node::after {
    border-top: none;
  }

  & > .el-tree-node::before {
    border-left: none;
  }

  .el-tree-node__expand-icon {
    font-size: 17px;

    // color: #000;
    &.is-leaf {
      color: transparent;
      // display: none;
    }
  }
}

::v-deep body .dialog-style.list-dialog .el-dialog__body {
  background: #F1F5FB;
  padding: 8px 0px 1px !important;
  height: 575px;
}

// ::v-deep .grid-height {
// 	height: calc(100vh - 270px) !important;
// }
::v-deep .vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -40px !important;
  position: absolute !important;
  z-index: 9;
  background-color: #ffffff;
}

body .dialog-style.list-dialog .el-dialog__body .multipleChoice {

  z-index: 99999;
}

::v-deep .vxe-form--wrapper .vxe-row {
  background-color: #f6f8fb;
}

::v-deep .vxe-form--item {
  font-size: 12px;
  padding: 0;
  margin-left: 7px;
  margin-right: 7px;
}

::v-deep .vxe-pager {
  height: 30px;
}
</style>


